import React, {useEffect, useRef, useState} from "react";
// import {useNavigate} from "react-router-dom"
import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab, { tabClasses } from '@mui/joy/Tab';
import TabPanel from '@mui/joy/TabPanel';
import OperationsMoney from "./operations-money";
import OperationsInstrumento from "./operations-instrumento";
import OperationsBonos from "./operations-bonos";
import OperationsFCI from "./operations-fci";

function Operations() {

    const [initialTab, setInitialTab] = useState(0)

    const handleChange = (event, newValue) => {
        let operationOption = JSON.parse(sessionStorage.getItem('operationOption'));
        if(operationOption){
            operationOption.tab = newValue
            sessionStorage.setItem('operationOption', JSON.stringify(operationOption) );
        }else{
            operationOption = { tab: newValue }
            sessionStorage.setItem('operationOption', JSON.stringify(operationOption) );
        }
        setInitialTab(newValue)
    }
    
    useEffect(() => {
        let operationOption = JSON.parse(sessionStorage.getItem('operationOption'));
        if(operationOption){
            setInitialTab(operationOption.tab)
        }else{
            setInitialTab(0)
        }
    }, [false])

    return (
        <div className="container-fluid flex-grow-1 container-p-y">
            
            <div className="row">

                <Tabs aria-label="tabs" value={initialTab} sx={{ bgcolor: 'transparent' }} onChange={handleChange}>
                    <TabList
                        disableUnderline
                        sx={{
                        p: 0.5,
                        gap: 0.5,
                        borderRadius: 'xl',
                        // bgcolor: 'background.level1',
                        bgcolor: 'rgba(131, 118, 109, 0.16)',
                        [`& .${tabClasses.root}[aria-selected="true"]`]: {
                            boxShadow: 'sm',
                            bgcolor: 'background.surface',
                            // bgcolor: '#FFFFFF',
                        },
                        }}
                    >
                        <Tab disableIndicator>Mercado</Tab>
                        <Tab disableIndicator>FCI</Tab>
                        <Tab disableIndicator>Inter. Moneda</Tab>
                        <Tab disableIndicator>Inter. Instrumentos</Tab>
                        
                    </TabList>
                            
                    <TabPanel value={0}>
                        <OperationsBonos />
                    </TabPanel>

                    <TabPanel value={1}>
                        <OperationsFCI />
                    </TabPanel>

                    <TabPanel value={2}>
                        <OperationsMoney />
                    </TabPanel>

                    <TabPanel value={3}>
                        <OperationsInstrumento />
                    </TabPanel>


                </Tabs>
            </div>
            
        </div>   
    );

}

export default Operations;